import { Button } from "Components/Button";
import { PreOrderList } from "Requests/Partners/PreBudgets";
import { Eye, ClipboardCheck, File } from "lucide-react";
import { useEffect, useState } from "react";
import { PREBUDGETSTATUS } from "Constants/PreBudget";
import { TooltipButtonDetails } from "./TooltipButtonDetails";
import { TRContent } from "../styles";

interface OrderListItemProps {
  order: PreOrderList;
}

export const OrderListItem = ({ order }: OrderListItemProps) => {
  const {
    email,
    full_name,
    client,
    status,
    document,
    created_at,
    id,
    locked_by,
    locked_at,
    products,
    files,
    appointment_at,
    budget_id,
    order_id,
  } = order;

  function getTimeRemaining() {
    if (locked_at) {
      const now = new Date().getTime();
      const distance = new Date(locked_at.replace(" ", "T")).getTime() - now;
      if (distance <= 0) {
        return "00:00";
      }

      return `${formatNumber(Math.floor((distance / 1000 / 60) % 60))}min`;
    }

    return "00:00";
  }

  const [timeLeft, setTimeLeft] = useState(getTimeRemaining());

  let creationDate = "";
  let scheduleInfo = "Não informado";

  const isPendingProcess = status.id === PREBUDGETSTATUS.processing;

  if (created_at) {
    const [dateSchedule] = created_at.split(" ");
    const [y, m, d] = dateSchedule.split("-");
    creationDate = `${d}/${m}/${y}`;
  }

  if (appointment_at) {
    const [date, time] = appointment_at.split(" ");
    const [y, m, d] = date.split("-");
    const timeSchedule = time.slice(0, -3);
    scheduleInfo = `${d}/${m}/${y}-${timeSchedule}`;
  }

  const onRedirectPreBudget = () => {
    if (!client.pre_flow) {
      return window.open(`/detalhes-pre-orcamento/${id}/domiciliar`);
    }

    if (files?.length >= 1 && products?.length === 0) {
      return window.open(`/converter-pre-orcamento-ia/${id}/domiciliar`);
    }

    return window.open(`/converter-pre-orcamento/${id}/domiciliar`);
  };

  function formatNumber(num: number) {
    return String(num).padStart(2, "0");
  }

  const onRedirectToBudget = (id: number) =>
    window.open(`/ficha-de-atendimento-parceiro/${id}/domiciliar`);

  const onRedirectToOrder = (id: number) =>
    window.open(`/ficha-de-pedido/${id}/`);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <TRContent>
      <td>{full_name}</td>
      <td>{document}</td>
      <td>{email}</td>
      <td>{scheduleInfo}</td>
      <td>{client.name}</td>
      <td>{creationDate || "Não informado"}</td>
      <td>{status.status}</td>

      {!isPendingProcess ? (
        <td>
          {locked_by && timeLeft !== "00:00" ? (
            <TooltipButtonDetails tooltip={`Edição liberada em ${timeLeft}`}>
              <Button
                textButton
                onClick={onRedirectPreBudget}
                classButton="click-blocked"
              >
                <Eye color="#80008059" />
              </Button>
            </TooltipButtonDetails>
          ) : (
            <>
              <TooltipButtonDetails tooltip="Visualizar pré-orçamento">
                <Button textButton onClick={onRedirectPreBudget}>
                  <Eye color="purple" />
                </Button>
              </TooltipButtonDetails>

              {budget_id && (
                <TooltipButtonDetails tooltip="Visualizar orçamento">
                  <Button
                    textButton
                    onClick={() => onRedirectToBudget(budget_id)}
                  >
                    <File color="purple" />
                  </Button>
                </TooltipButtonDetails>
              )}

              {order_id && (
                <TooltipButtonDetails tooltip="Visualizar pedido">
                  <Button
                    textButton
                    onClick={() => onRedirectToOrder(order_id)}
                  >
                    <ClipboardCheck color="purple" />
                  </Button>
                </TooltipButtonDetails>
              )}
            </>
          )}
        </td>
      ) : null}
    </TRContent>
  );
};
